import { useCallback, useMemo, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { deleteComment } from "../../../../../../../services/apiComment";
import { useResponsive } from "../../../../../../../hooks/useResponsive";
import { currentUserId } from "../../../../../../../utils/constants";
import GetHeadShotName from "../../../../../../../utils/getHeadShotName";
import { hasImage } from "../../../../../../../utils";
import useMutate from "../../../../../../../hooks/useMutate";

export function useCommentItemState({ cardId, data }) {
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");
  const isBetween300And699 = useResponsive("between", 300, 699);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const headShotName = GetHeadShotName(data?.username);
  const canEdit = data?.author_id == currentUserId();

  const { mutate: deleteCommentMutate } = useMutate(
    deleteComment,
    [],
    () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["comment", cardId],
      });
      queryClient.invalidateQueries({
        queryKey: ["history", String(cardId)],
      });
      setLoading(false);
      setShowDelete(false);
    },
    () => {
      setLoading(false);
      setShowDelete(false);
    }
  );

  const handleEdit = useCallback(() => {
    setShowEdit(true);
    setAnchorEl(null);
  }, []);

  const handleDelete = useCallback(() => {
    setShowDelete(true);
    setAnchorEl(null);
  }, []);

  const handleDeleteClose = useCallback(() => {
    setShowDelete(false);
  }, []);

  const handleDeleteConfirm = useCallback(() => {
    setLoading(true);
    deleteCommentMutate(data?.comment_id);
  }, [data?.comment_id, deleteCommentMutate]);

  const avatarStyle = useMemo(
    () =>
      !hasImage(data?.user_image) && {
        bgcolor: data?.user_profile_color?.background,
        color: data?.user_profile_color?.text,
      },
    [data]
  );

  return {
    anchorEl,
    avatarStyle,
    canEdit,
    handleDelete,
    handleDeleteClose,
    handleDeleteConfirm,
    handleEdit,
    headShotName,
    isBetween300And699,
    isMobile,
    loading,
    setAnchorEl,
    setShowEdit,
    showDelete,
    showEdit,
  };
}
